(function () {
  var root = document.querySelector('[data-loky-home]');
  if (!root) return;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealItems = root.querySelectorAll('[data-loky-reveal]');
  var counters = root.querySelectorAll('[data-loky-counter]');

  function reveal(item) {
    item.classList.add('is-visible');
  }

  function animateCounter(counter) {
    if (counter.dataset.counted || prefersReducedMotion) return;
    counter.dataset.counted = 'true';
    var target = Number(counter.getAttribute('data-loky-counter'));
    var suffix = counter.getAttribute('data-loky-suffix') || '';
    var startedAt = null;
    var duration = 1200;

    function frame(timestamp) {
      if (!startedAt) startedAt = timestamp;
      var progress = Math.min((timestamp - startedAt) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      counter.textContent = Math.floor(target * eased).toLocaleString() + suffix;
      if (progress < 1) window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        entry.target.querySelectorAll('[data-loky-counter]').forEach(animateCounter);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14 });
    revealItems.forEach(function (item) { observer.observe(item); });
  } else {
    revealItems.forEach(reveal);
    counters.forEach(animateCounter);
  }

  var faq = root.querySelector('[data-loky-faq]');
  if (faq) {
    faq.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button) return;
      var item = button.parentNode;
      var wasOpen = item.classList.contains('is-open');
      faq.querySelectorAll('.loky-faq__item').forEach(function (faqItem) {
        faqItem.classList.remove('is-open');
        faqItem.querySelector('button').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  }

  var heroMedia = root.querySelector('.loky-hero__media');
  var stickyHelp = root.querySelector('[data-loky-sticky-help]');
  var backToTop = root.querySelector('[data-loky-back-to-top]');
  var ticking = false;

  function updateScrollState() {
    var offset = window.pageYOffset || document.documentElement.scrollTop;
    if (heroMedia && !prefersReducedMotion) {
      heroMedia.style.transform = 'scale(1.055) translate3d(0, ' + Math.min(offset * 0.045, 34) + 'px, 0)';
    }
    if (stickyHelp) stickyHelp.classList.toggle('is-visible', offset > 720);
    if (backToTop) backToTop.classList.toggle('is-visible', offset > 760);
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  }, { passive: true });
  updateScrollState();

  if (backToTop) {
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
  }

  root.querySelectorAll('[data-loky-wishlist]').forEach(function (button) {
    button.addEventListener('click', function () {
      button.classList.toggle('is-saved');
      button.setAttribute('aria-pressed', button.classList.contains('is-saved') ? 'true' : 'false');
    });
  });
})();
